import { useRef, useState } from 'react';
import InputAuthorizedPersonPanel from './InputAuthorizedPersonPanel';
import { Modal } from 'react-bootstrap';
import { useCustomer } from '../../../Providers/CustomerProvider';
import { useAuth } from '../../../Providers/AuthProvider';
import LoadingSpinner from '../../Components/LoadingSpinner';
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../../Data/UserRolesEnum.ts';
import { validateEmail, validatePhoneNoWith48 } from '../../../Helpers/ValidatorHelper.jsx';
import { capitalizeFirstLetter } from '../../../Helpers/CustomConverter.jsx';

const AddEditAuthorizedPerson = ({ handlingUser, setHandlingUser, isAddPersonVisible, setIsAddPersonVisible, setNewAddedAuthorizedPersonRecNo }) => {
    const { authState } = useAuth();
    const { addPersonAuthorizedToCollectDelivery, handleGetPeopleAuthorizedToCollectDelivery, updatePersonAuthorizedToCollectDelivery, setAuthorizedPersons } = useCustomer()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')
    const { isUserHasAccess } = useCheckUserRole()
    const dateToRef = useRef(null)

    const handleEditPerson = (e) => {
        const { name, value } = e.target;
        setError('')
        if (name == 'name' || name == 'surname' || name == 'position') {
            const capitalizeValue = capitalizeFirstLetter(value)
            setHandlingUser({
                ...handlingUser,
                [name]: capitalizeValue
            })
        } else {
            setHandlingUser({
                ...handlingUser,
                [name]: value
            })
        }

    }

    const handleChangeAuthorizationType = () => {
        if (handlingUser.isExpAuthorization) {
            if (dateToRef.current) {
                dateToRef.current.instance.reset();
            }
            setHandlingUser({
                ...handlingUser,
                isExpAuthorization: !handlingUser.isExpAuthorization,
                expirationDate: ''
            })
        } else {
            setHandlingUser({
                ...handlingUser,
                isExpAuthorization: !handlingUser.isExpAuthorization
            })
        }
    }

    const DateToOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10);
            setHandlingUser({
                ...handlingUser,
                expirationDate: selectedDate
            })
        }
    }

    const handleCancelButtonClick = () => {
        setHandlingUser({ name: '', surname: '', position: '', phoneNumber: '', email: '', recNo: 0, isExpAuthorization: false, expirationDate: '' })
        setIsAddPersonVisible(false);
    }

    const handleAddEditPerson = async () => {
        if (!handlingUser.name) {
            setError("Podaj imię!")
            return;
        } else if (!handlingUser.surname) {
            setError("Podaj nazwisko!")
            return;
        } else if (handlingUser.email.trim() && !validateEmail(handlingUser.email)) {
            setError("Podaj prawidłowy adres e-mail!")
            return;
        } else if (!handlingUser.phoneNumber) {
            setError("Podaj numer telefonu!")
            return;
        } else if (!validatePhoneNoWith48(handlingUser.phoneNumber)) {
            setError("Podaj prawidłowy numer telefonu!")
            return;
        }
        setIsLoading(true);
        var result = true
        if (isUserHasAccess(UserRole.Admin)) {
            if (handlingUser.recNo > 0) {
                result = await updatePersonAuthorizedToCollectDelivery(authState.custId, handlingUser.name, handlingUser.surname, handlingUser.position, handlingUser.phoneNumber, handlingUser.email, handlingUser.recNo, handlingUser.expirationDate)
            } else {
                result = await addPersonAuthorizedToCollectDelivery(authState.custId, handlingUser.name, handlingUser.surname, handlingUser.position, handlingUser.phoneNumber, handlingUser.email, handlingUser.expirationDate)
                if (setNewAddedAuthorizedPersonRecNo) {
                    setNewAddedAuthorizedPersonRecNo(result)
                }
            }
        }
        setIsLoading(false)
        if (result) {
            if (isUserHasAccess(UserRole.Admin)) {
                handleGetPeopleAuthorizedToCollectDelivery()
            }
            else {
                var tmpAuthorizedPerson = {
                    city: '',
                    custId: '999999',
                    effectiveDate: handlingUser.expirationDate,
                    email: handlingUser.email,
                    houseNum: '',
                    localNum: '',
                    name: handlingUser.name,
                    phoneNumber: handlingUser.phoneNumber,
                    position: handlingUser.position,
                    recNo: '0',
                    street: '',
                    surname: handlingUser.surname,
                    zipCode: ''
                }
                setAuthorizedPersons(prev => [
                    ...prev.filter(x => x.custId !== '999999'),
                    tmpAuthorizedPerson
                ])
                if (setNewAddedAuthorizedPersonRecNo) {
                    setNewAddedAuthorizedPersonRecNo('0')
                }
            }
            setHandlingUser({ name: '', surname: '', position: '', phoneNumber: '', email: '', recNo: 0, isExpAuthorization: false, expirationDate: '' })
            setIsAddPersonVisible(false);
        } else {
            setError("Błąd podczas zapisu upoważnionej osoby!")
        }
    }

    if (!isUserHasAccess(UserRole.Admin) && handlingUser.recNo > 0) {
        return <Modal size='lg' show={isAddPersonVisible} onHide={handleCancelButtonClick} centered>
            <Modal.Header closeButton>
                <Modal.Title>Brak uprawnień do edycji osób!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column' style={{ fontSize: '1.3rem' }}>
                    <span className='error-text-color'>Brak uprawnień!</span>
                    <span className='error-text-color'>Skontaktuj się z administratorem strony</span>
                </div>
            </Modal.Body>
        </Modal>
    }
    return <>
        <Modal size='lg' show={isAddPersonVisible} onHide={handleCancelButtonClick} centered>
            <Modal.Header closeButton>
                <Modal.Title>Użytkownik upoważniony do odbioru</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (<LoadingSpinner />) : (<><InputAuthorizedPersonPanel authorizedPerson={handlingUser} handleEditPerson={handleEditPerson} handleAddEditPerson={handleAddEditPerson} handleDateChange={DateToOnValueChanged} handleChangeAuthorizationType={handleChangeAuthorizationType} dateToRef={dateToRef} />
                    {error.length > 0 ? (<div className="row error-text-color justify-content-center mb-4">{error}</div>) : (<></>)}</>)}
            </Modal.Body>
        </Modal>
    </>
}

export default AddEditAuthorizedPerson; 